import { Injectable } from '@angular/core';
import { debounceTime, distinctUntilChanged, fromEvent, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FullscreenUtilService {
  /**
   * Returns an observable that emits the current fullscreen state.
   * @returns {Observable<boolean>} true if fullscreen, false otherwise
   *
   * Note:
   * - JavaScript fullscreenchange event is not fired when the user presses the ESC key
   * - ESC key event does not work in fullscreen mode
   * - Hence, we are using window.resize event to detect fullscreen state change
   */
  fullscreenChange$ = fromEvent(window, 'resize').pipe(
    debounceTime(20), // debounce to avoid multiple events on resize
    map(() => this.isFullscreen), // map to fullscreen state
    distinctUntilChanged(), // emit only if the fullscreen state changes
    shareReplay({ bufferSize: 1, refCount: true }), // share the observable
  );

  /**
   * Check if the browser is in fullscreen mode.
   */
  get isFullscreen() {
    // Note: we can also use document.fullscreenElement to check if the browser is in fullscreen mode
    return window.innerHeight === screen.height;
  }
}
